/*
 * @Author: 小周
 * @Date: 2023-09-07 11:47:06
 * @LastEditTime: 2024-06-24 11:34:28
 * @LastEditors: MrZHLF
 * @Description: 用户存储
 */

import store from 'store'
const KEY_RAW = 'realUserInfo'

/**
 * 设置User信息
 * @param {Object} User User
 */
export const setUser = (User) => {
  store.set(KEY_RAW, User)
}

/**
 * 获取User
 */
export const getUser = () => {
  return store.get(KEY_RAW)
}

/**
 * 清除User
 */
export const rmUser = () => {
  store.remove(KEY_RAW)
}
